import { render, staticRenderFns } from "./PsGroups.vue?vue&type=template&id=24fc3f54&scoped=true&"
import script from "./PsGroups.vue?vue&type=script&lang=js&"
export * from "./PsGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc3f54",
  null
  
)

export default component.exports